import LayoutClassicTour from "@/components/Layout/ClassicTour.vue"
import LayoutPlusTour from "@/components/Layout/PlusTour.vue"

export const useTourLayout = (site) => {
  if (site.slug === "pornplus") {
    return markRaw(LayoutPlusTour)
  }
  return markRaw(LayoutClassicTour)
}
